<template>
	<!-- 免责声明 -->
	<div class="agreement disclaimer">
		<img class="img_bg" src="../../assets/img/login/agreement_re.png" alt="免责声明" />
		<img class="close" src="../../assets/img/login/close.png" alt="关闭icon" @click="closeActive()" />
		<div class="text_content">
			<p>免责声明</p>
			<div class="content agreementContent">
				<p>使用本站点前，请仔细阅读下列条款：</p>
				<p>为用户提供线上企业股权估值及其他相关服务的网络平台。</p>
				<p>
					1、安徽亿众依据国际通用的估值模型和自主研发的估值指标体系，在线进行企业股权估值。所采用的数据均为用户提供和公开渠道可获取，安徽亿众不对前述数据的准确性、完整性和真实性负有实质审核的义务。网站自动生成的相关报告，仅给用户提供参考股权估值区间，不能作为企业并购、转让等交易的法定依据，并不构成任何投资建议，投资者据此做出的任何投资决策与安徽亿众无关。
				</p>
				<p>
					2、用户应妥善保管用户账号和密码等个人信息，安徽亿众承诺不向任何第三方泄露用户个人信息或其他商业信息。除非司法机关、监管机构或其他政府部门依据法律程序要求安徽亿众提供，安徽亿众将根据相关部门的要求提供相关信息资料，及时通知用户。
				</p>
				<p>
					3、安徽亿众挑选具备良好声誉的网站作为友情链接列入网站进行展示，供用户浏览和参考。但该行为并不视为安徽亿众与所列示网站一定具有合作关系，请自行对相关网站的内容进行审慎辨别及判断，对于用户使用外部链接网站而引起的损失或损害，安徽亿众不承担任何责任。
				</p>
				<p>4、您使用安徽亿众时，应遵守中国有关法律规定与本声明的内容，不得破坏安徽亿众运行安全，不得利用安徽亿众进行任何违法活动，不得损害安徽亿众所有者的合法权益。</p>
				<p>5、除转载信息外，安徽亿众所有站内原创内容的著作权属于安徽亿众数科数字科技有限公司所有。任何机构或者个人未经安徽亿众数科数字科技有限公司书面许可，不得以任何形式使用前述内容。</p>
				<p>您浏览和使用安徽亿众即视为您接受以上条款。安徽亿众在法律许可范围内有权对本声明进行解释和修改，并将以网站信息更新的方式另行通知。</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			show: {
				type: Boolean
			}

		},
		data() {
			return {


			}
		},
		methods: {
			closeActive() {
				this.$emit('childData', false);
			}

		}

	}
</script>

<style>
</style>